/**
 * Olivia's Protect - internal app
 * - Adds a toggle in the cart drawer to include an insurance line item
 * - Dynamically selects the correct variant based on cart subtotal (pre-tax, pre-shipping)
 *
 * IMPORTANT: Configure the product handle and variant mapping below.
 */

(function () {
  try {
    if (
      typeof theme !== "undefined" &&
      theme.settings &&
      theme.settings.pmo_enable === false
    )
      return;
  } catch (e) {}
  var PROTECT_PRODUCT_HANDLE = "oliviasprotect";
  var PROTECT_PRODUCT_ID = "15242854760831";
  // Map of upper-bound subtotal (in shop currency minor units) to variant ID
  // Example tiers in GBP: 0–250 -> £2.50, 251–500 -> £5, 501–750 -> £7.50
  // Fill in with real variant IDs from your ProtectMyOrder product
  // Subtotal thresholds are in cents. Adjust as desired.
  // 0–£250 → £2.50, £250.01–£500 → £5, £500.01–£1,000 → £10, etc.
  var TIERS = [
    { maxSubtotal: 25000, variantId: 55893306442111, price: 250 }, // £2.50
    { maxSubtotal: 50000, variantId: 55893306474879, price: 500 }, // £5.00
    { maxSubtotal: 100000, variantId: 55893706572159, price: 1000 }, // £10.00
    { maxSubtotal: 200000, variantId: 55893706604927, price: 2000 }, // £20.00
    { maxSubtotal: 300000, variantId: 55893706637695, price: 3000 }, // £30.00
    { maxSubtotal: 400000, variantId: 55893706670463, price: 4000 }, // £40.00
    { maxSubtotal: 999999999, variantId: 55893706703231, price: 5000 }, // £50.00 (≥ £4,001)
  ];

  // FALLBACK: to query variant IDs by title, you can configure here
  var VARIANT_TITLE_BY_TIER_INDEX = ["£2.50", "£5.00"];

  var STORAGE_KEY = "pmo:enabled";
  var state = {
    product: null,
    variantIdByTier: {},
    enabled: false,
    currentVariantId: null,
    isUpdating: false,
    refreshTimer: null,
    autoToggleTimer: null,
    autoToggleDone: false,
    suppressEnsureOnce: false,
    cartFetchInFlight: false,
    userChangeInFlight: false,
    userChangeTimer: null,
    ensuringInFlight: false,
    ensureDebounceTimer: null,
    pendingVisualOnAt: null,
    visualOnTimer: null,
    openObserver: null,
    lastSyntheticOpenAt: 0,
  };

  var DEBUG = true; // enable debug logging temporarily

  function pmolog() {
    if (!DEBUG) return;
    try {
      var args = Array.prototype.slice.call(arguments);
      args.unshift("[PMO]");
      console.log.apply(console, args);
    } catch (e) {}
  }

  function logStatus(tag, cart) {
    try {
      //console.log("[PMO STATUS]", tag, {
      //  storedEnabled: getStoredEnabled(),
      //  stateEnabled: state.enabled,
      //  hasProtect: !!findProtectLine(cart),
      //  nonProtectQty: countNonProtectQuantity(cart),
      //});
    } catch (e) {}
  }

  function getStoredEnabled() {
    try {
      var v = localStorage.getItem(STORAGE_KEY);
      if (v === null || v === undefined) return null; // no preference yet
      return v === "1";
    } catch (e) {
      return null;
    }
  }

  function setStoredEnabled(enabled) {
    try {
      localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
    } catch (e) {}
  }

  function formatMoney(cents) {
    try {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    } catch (e) {
      // Fallback: simple GBP style
      return "£" + (cents / 100).toFixed(2);
    }
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (r) {
      return r.json();
    });
  }

  function getCart() {
    return fetchJSON("/cart.js");
  }

  function addVariant(variantId) {
    if (!variantId) {
      console.error("[ProtectMyOrder] Missing variantId for addVariant");
      return Promise.reject(new Error("Missing variantId"));
    }
    return fetchJSON("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
  }

  function changeLineByKey(key, quantity) {
    return fetchJSON("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
  }

  function removeLineByKey(key) {
    return changeLineByKey(key, 0);
  }

  function updateSubtotalUI(subtotal) {
    var priceEl = document.getElementById("pmo-price");
    if (!priceEl) return;
    var tier = getTier(subtotal);
    if (tier) {
      priceEl.innerHTML = formatMoney(tier.price);
    } else {
      priceEl.textContent = "";
    }
  }

  function setDrawerSubtotal(totalCents) {
    try {
      if (typeof totalCents !== "number") return;
      var nodes = [];
      try {
        nodes = Array.prototype.slice.call(
          document.querySelectorAll(
            "#CartDrawer [data-subtotal], .cart-drawer__body [data-subtotal]"
          )
        );
      } catch (e) {}
      if (!nodes || !nodes.length) return;
      var html = formatMoney(totalCents);
      nodes.forEach(function (el) {
        try {
          el.innerHTML = html;
        } catch (e) {}
      });
    } catch (e) {}
  }

  function updateDisplayedSubtotal(cart) {
    if (!cart) return;
    var expected = typeof cart.total_price === "number" ? cart.total_price : 0;
    var protectLine = findProtectLine(cart);
    if (state.enabled) {
      if (!protectLine) {
        var base = computeSubtotalExcludingProtect(cart);
        var tier = getTier(base);
        if (tier && typeof tier.price === "number") expected += tier.price;
      }
    } else {
      if (protectLine && typeof protectLine.final_line_price === "number") {
        expected -= protectLine.final_line_price;
      }
    }
    setDrawerSubtotal(expected);
  }

  function getTier(subtotal) {
    for (var i = 0; i < TIERS.length; i++) {
      if (subtotal <= TIERS[i].maxSubtotal) return TIERS[i];
    }
    return TIERS.length ? TIERS[TIERS.length - 1] : null;
  }

  function resolveVariantIds(product) {
    // If TIERS already contain variantId values, keep them
    var anyMissing = TIERS.some(function (t) {
      return !t.variantId;
    });
    if (!anyMissing) return;
    if (!product || !Array.isArray(product.variants)) return;

    function normalizeTitle(s) {
      return String(s || "")
        .replace(/<[^>]*>/g, "")
        .replace(/[£$€\s]/g, "")
        .trim()
        .toLowerCase();
    }

    function centsFromVariantPrice(v) {
      if (typeof v === "number") {
        // Usually already in cents
        return Math.round(v);
      }
      var str = String(v || "").trim();
      if (!str) return NaN;
      if (str.indexOf(".") >= 0) {
        var n = parseFloat(str);
        if (isNaN(n)) return NaN;
        return Math.round(n * 100);
      }
      var n2 = parseInt(str, 10);
      return isNaN(n2) ? NaN : n2;
    }

    VARIANT_TITLE_BY_TIER_INDEX.forEach(function (title, index) {
      var matched = product.variants.find(function (v) {
        return normalizeTitle(v.title) === normalizeTitle(title);
      });
      if (!matched) {
        // Fallback: match by price in cents
        var desired = TIERS[index].price;
        matched = product.variants.find(function (v) {
          return centsFromVariantPrice(v.price) === desired;
        });
      }
      if (matched) {
        TIERS[index].variantId = matched.id;
      }
    });

    if (DEBUG) {
      console.debug("[ProtectMyOrder] variant mapping", JSON.stringify(TIERS));
    }
  }

  function findProtectLine(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var handleMatch = cart.items.find(function (item) {
      return item.handle === PROTECT_PRODUCT_HANDLE;
    });
    return handleMatch || null;
  }

  function computeSubtotalExcludingProtect(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var sum = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.handle === PROTECT_PRODUCT_HANDLE) continue;
      var line =
        typeof item.final_line_price === "number"
          ? item.final_line_price
          : null;
      if (line === null) line = (item.price || 0) * (item.quantity || 0);
      sum += line;
    }
    return sum;
  }

  function countNonProtectQuantity(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var count = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.handle === PROTECT_PRODUCT_HANDLE) continue;
      count += item.quantity || 0;
    }
    return count;
  }

  function ensureCorrectVariant(cart) {
    var subtotal = computeSubtotalExcludingProtect(cart);
    updateSubtotalUI(subtotal);
    updateDisplayedSubtotal(cart);

    // If there are no non-protect items, ensure PMO is removed regardless of toggle
    var nonProtectQty = countNonProtectQuantity(cart);
    if (nonProtectQty === 0) {
      var onlyProtect = findProtectLine(cart);
      if (onlyProtect) {
        return removeLineByKey(onlyProtect.key).then(
          function () {
            state.enabled = false;
            setStoredEnabled(false);
            syncToggleUI(false);
            return true;
          },
          function () {
            return true;
          }
        );
      }
      return Promise.resolve(false);
    }

    if (!state.enabled) {
      // Remove if present
      var existing = findProtectLine(cart);
      if (existing)
        return removeLineByKey(existing.key).then(
          function () {
            return true;
          },
          function () {
            return true;
          }
        );
      return Promise.resolve(false);
    }

    var tier = getTier(subtotal);
    if (!tier || !tier.variantId) {
      return Promise.resolve(false);
    }

    var existingLine = findProtectLine(cart);
    if (!existingLine) {
      if (DEBUG)
        console.debug("[ProtectMyOrder] adding variant", tier.variantId);
      return addVariant(tier.variantId).then(function () {
        return true;
      });
    }

    if (existingLine.quantity !== 1) {
      if (DEBUG)
        console.debug(
          "[ProtectMyOrder] forcing quantity to 1 for key",
          existingLine.key
        );
      return changeLineByKey(existingLine.key, 1).then(function () {
        return true;
      });
    }

    if (existingLine.variant_id !== tier.variantId) {
      // Replace by removing old then adding new
      if (DEBUG)
        console.debug(
          "[ProtectMyOrder] switching variant",
          existingLine.variant_id,
          "=>",
          tier.variantId
        );
      return removeLineByKey(existingLine.key)
        .then(function () {
          return addVariant(tier.variantId);
        })
        .then(function () {
          return true;
        });
    }

    return Promise.resolve(false);
  }

  function safeEnsure(cart) {
    if (state.ensuringInFlight) return Promise.resolve(false);
    state.ensuringInFlight = true;
    return ensureCorrectVariant(cart)
      .then(function (changed) {
        state.ensuringInFlight = false;
        return changed;
      })
      .catch(function (e) {
        state.ensuringInFlight = false;
        return false;
      });
  }

  function noop() {}

  function syncToggleUI(enabled) {
    var toggle = document.getElementById("pmo-toggle");
    if (toggle) toggle.checked = !!enabled;
  }

  function cancelPendingToggleAnimations() {
    if (state.autoToggleTimer) {
      clearTimeout(state.autoToggleTimer);
      state.autoToggleTimer = null;
    }
    state.pendingVisualOnAt = null;
    if (state.visualOnTimer) {
      clearTimeout(state.visualOnTimer);
      state.visualOnTimer = null;
    }
  }

  // Apply preference to UI immediately — no OFF→ON animation on drawer open.
  function applyTogglePreference(cart) {
    try {
      var stored = getStoredEnabled();
      if (stored !== null) {
        state.enabled = !!stored;
      } else if (cart && countNonProtectQuantity(cart) > 0) {
        // First visit with items: default ON without flicker
        state.enabled = true;
      } else {
        state.enabled = false;
      }
    } catch (e) {
      state.enabled = false;
    }
    cancelPendingToggleAnimations();
    syncToggleUI(state.enabled);
  }

  function onToggleChange(evt) {
    // User took control — cancel any scheduled auto/visual toggles
    cancelPendingToggleAnimations();
    state.autoToggleDone = true;
    state.enabled = !!evt.target.checked;
    setStoredEnabled(state.enabled);
    state.isUpdating = true;
    // Prevent ensureCorrectVariant from running again on the immediate cart:updated
    state.suppressEnsureOnce = state.enabled === true;
    if (!state.enabled) {
      // OFF path: subtract PMO price immediately and remove PMO line
      getCart().then(function (cart) {
        updateDisplayedSubtotal(cart);
        var existing = findProtectLine(cart);
        if (existing) {
          removeLineByKey(existing.key).then(function () {
            scheduleRefresh();
          });
        } else {
          scheduleRefresh();
        }
      });
      return;
    }

    // ON path: add/switch PMO variant as needed
    getCart()
      .then(function (cart) {
        updateDisplayedSubtotal(cart);
        return safeEnsure(cart);
      })
      .then(function (changed) {
        if (changed) scheduleRefresh();
      });
  }

  function attachToggleHandler() {
    var toggle = document.getElementById("pmo-toggle");
    if (!toggle) return;
    toggle.removeEventListener("change", onToggleChange);
    toggle.addEventListener("change", onToggleChange);
    syncToggleUI(state.enabled);
  }

  function initOnce() {
    // Global default is ON until the user explicitly turns it OFF
    state.enabled = !!getStoredEnabled();
    // Do not bind or sync yet to avoid initial ON flicker.
  }

  function fetchProtectProduct() {
    return fetchJSON("/products/" + PROTECT_PRODUCT_HANDLE + ".js")
      .then(function (product) {
        state.product = product;
        resolveVariantIds(product);
      })
      .catch(function () {
        if (!PROTECT_PRODUCT_ID) return;
        return fetchJSON("/products/" + PROTECT_PRODUCT_ID + ".js")
          .then(function (product) {
            state.product = product;
            resolveVariantIds(product);
          })
          .catch(function () {});
      });
  }

  // Product added: clear any forced-empty inline styles immediately so the
  // drawer cannot open blank while buildCart / cart:updated are still racing.
  document.addEventListener("ajaxProduct:added", function () {
    setDrawerEmptyState(false);
  });

  // Re-attach after cart rebuilds or drawer refresh
  document.addEventListener("cart:build", function () {
    getCart().then(function (cart) {
      logStatus("cart:build", cart);
      ensureToggleExists();
      applyTogglePreference(cart);
      try {
        var nonProtectQty = countNonProtectQuantity(cart);
        setDrawerEmptyState(nonProtectQty === 0);
      } catch (e) {}
      attachToggleHandler();
      updateSubtotalUI(computeSubtotalExcludingProtect(cart));
      updateDisplayedSubtotal(cart);
      hideProtectItemInDrawer();
      if (state.enabled === true && countNonProtectQuantity(cart) > 0) {
        safeEnsure(cart).then(function (changed) {
          if (changed) scheduleRefresh();
        });
      } else if (state.enabled !== true) {
        // Preference OFF: ensure Protect line is not left behind
        var existing = findProtectLine(cart);
        if (existing) {
          removeLineByKey(existing.key).then(function () {
            scheduleRefresh();
          });
        }
      }
    });
  });

  document.addEventListener("cart:updated", function (evt) {
    var cart = evt && evt.detail && evt.detail.cart ? evt.detail.cart : null;
    var proceed = function (cartData) {
      if (!cartData) return;
      // Drawer content may be rebuilt; ensure toggle exists and is bound
      ensureToggleExists();
      applyTogglePreference(cartData);
      attachToggleHandler();
      // If no non-PMO items remain, force-remove any PMO line and show empty basket
      try {
        var nonProtectQty = countNonProtectQuantity(cartData);
        if (nonProtectQty === 0) {
          var onlyProtect = findProtectLine(cartData);
          if (onlyProtect) {
            state.isUpdating = true;
            state.enabled = false;
            setStoredEnabled(false);
            cancelPendingToggleAnimations();
            syncToggleUI(false);
            setDrawerEmptyState(true);
            removeLineByKey(onlyProtect.key).then(function () {
              state.isUpdating = false;
              try {
                document.dispatchEvent(new CustomEvent("cart:build"));
              } catch (e) {}
            });
            return;
          }
          // No PMO line either: enforce empty state UI and hide PMO widget (do not block adds)
          setDrawerEmptyState(true);
        } else {
          // Non-empty: ensure drawer shows content view again
          setDrawerEmptyState(false);
        }
      } catch (e) {}
      if (state.isUpdating) {
        // End updating phase on the first detailed cart update; do not schedule another refresh
        state.isUpdating = false;
      }
      updateDisplayedSubtotal(cartData);
      maybeTriggerAutoToggle(cartData);
      if (state.enabled && !state.suppressEnsureOnce) {
        if (state.ensureDebounceTimer) clearTimeout(state.ensureDebounceTimer);
        state.ensureDebounceTimer = setTimeout(function () {
          state.ensureDebounceTimer = null;
          safeEnsure(cartData).then(function (changed) {
            if (changed) scheduleRefresh();
          });
        }, 150);
      }
      updateSubtotalUI(computeSubtotalExcludingProtect(cartData));
      updateDisplayedSubtotal(cartData);
      state.suppressEnsureOnce = false;
    };
    if (cart) return proceed(cart);
    if (state.cartFetchInFlight) return;
    state.cartFetchInFlight = true;
    getCart()
      .then(function (c) {
        proceed(c);
      })
      .finally(function () {
        state.cartFetchInFlight = false;
      });
  });

  function scheduleRefresh() {
    if (state.refreshTimer) return;
    if (state.userChangeInFlight) return; // avoid clobbering user-driven changes
    state.refreshTimer = setTimeout(function () {
      state.refreshTimer = null;
      try {
        if (
          typeof window !== "undefined" &&
          typeof window.refreshCartDrawer === "function"
        ) {
          var maybePromise = window.refreshCartDrawer();
          if (maybePromise && typeof maybePromise.then === "function") {
            maybePromise
              .then(function () {
                document.dispatchEvent(new CustomEvent("cart:updated"));
              })
              .catch(function () {});
          } else {
            document.dispatchEvent(new CustomEvent("cart:updated"));
          }
        } else {
          document.dispatchEvent(new CustomEvent("cart:build"));
        }
      } catch (e) {
        document.dispatchEvent(new CustomEvent("cart:build"));
      }
    }, 120);
  }

  // Observe cart drawer opening to (re)bind the toggle
  document.addEventListener("cart:open", function () {
    getCart().then(function (cart) {
      logStatus("cart:open", cart);
      ensureToggleExists();
      applyTogglePreference(cart);
      try {
        setDrawerEmptyState(countNonProtectQuantity(cart) === 0);
      } catch (e) {}
      attachToggleHandler();
      updateSubtotalUI(computeSubtotalExcludingProtect(cart));
      updateDisplayedSubtotal(cart);
      hideProtectItemInDrawer();
      if (state.enabled === true && countNonProtectQuantity(cart) > 0) {
        safeEnsure(cart).then(function (changed) {
          if (changed) scheduleRefresh();
        });
      } else {
        maybeTriggerAutoToggle(cart);
      }
      // Re-bind once after open in case drawer HTML was replaced — keep UI stable
      setTimeout(function () {
        getCart().then(function (c2) {
          ensureToggleExists();
          applyTogglePreference(c2);
          attachToggleHandler();
          updateDisplayedSubtotal(c2);
          hideProtectItemInDrawer();
          logStatus("cart:open:post-bind", c2);
        });
      }, 500);
    });
  });

  // Initialize
  document.addEventListener("DOMContentLoaded", function () {
    fetchProtectProduct().then(initOnce);
    try {
      // Mark when the user is actively changing quantities/removing items
      document.body.addEventListener("click", function (e) {
        var el = e.target.closest(
          "#CartDrawer .js-cart-remove-item_drawer, #CartDrawer .js-qty__adjust"
        );
        if (!el) return;
        state.userChangeInFlight = true;
        if (state.userChangeTimer) clearTimeout(state.userChangeTimer);
        state.userChangeTimer = setTimeout(function () {
          state.userChangeInFlight = false;
          state.userChangeTimer = null;
        }, 2000);
      });
      // Log status immediately on page load
      try {
        getCart().then(function (cart) {
          logStatus("dom:ready", cart);
        });
      } catch (e) {}

      // Ensure we emit cart:open when the drawer becomes visible (fallback for paths that don't dispatch)
      try {
        if (!state.openObserver) {
          var emitOpenIfVisible = function () {
            if (!isDrawerOpen()) return;
            var now = Date.now();
            if (now - state.lastSyntheticOpenAt < 500) return; // debounce
            state.lastSyntheticOpenAt = now;
            try {
              document.dispatchEvent(new CustomEvent("cart:open"));
            } catch (e) {}
          };
          state.openObserver = new MutationObserver(function () {
            emitOpenIfVisible();
          });
          state.openObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ["class"],
          });
          var cd = document.querySelector("#CartDrawer");
          if (cd)
            state.openObserver.observe(cd, {
              attributes: true,
              attributeFilter: ["class", "style"],
            });
          // Also run once shortly after load in case it's already open
          setTimeout(emitOpenIfVisible, 300);
        }
      } catch (e) {}
    } catch (e) {}
  });

  function maybeTriggerAutoToggle(cart) {
    try {
      if (state.autoToggleDone) return;
      // Respect an explicit OFF preference from the user
      try {
        var storedPref = getStoredEnabled();
        if (storedPref === false) {
          state.enabled = false;
          syncToggleUI(false);
          state.autoToggleDone = true;
          pmolog("auto-toggle: skipped due to stored OFF");
          return;
        }
        if (storedPref === true) {
          state.enabled = true;
          syncToggleUI(true);
          state.autoToggleDone = true;
          return;
        }
      } catch (e) {}
      if (!isDrawerOpen()) return;
      var nonProtectQty = countNonProtectQuantity(cart);
      var hasProtect = !!findProtectLine(cart);
      if (nonProtectQty < 1) return;

      // No stored preference yet: default ON immediately (no OFF→ON animation)
      state.autoToggleDone = true;
      state.enabled = true;
      setStoredEnabled(true);
      syncToggleUI(true);
      updateDisplayedSubtotal(cart);
      pmolog("auto-toggle: enabling immediately (no animation)");
      if (!hasProtect) {
        state.isUpdating = true;
        ensureCorrectVariant(cart).then(function () {
          state.isUpdating = false;
          scheduleRefresh();
        });
      }
    } catch (e) {}
  }

  function isDrawerOpen() {
    try {
      if (
        document &&
        document.body &&
        document.body.classList &&
        document.body.classList.contains("cart-drawer-open")
      )
        return true;
      var d = document.querySelector("#CartDrawer");
      if (d && d.classList && d.classList.contains("drawer--is-open"))
        return true;
    } catch (e) {}
    return false;
  }

  // Kept as a no-op for safety if anything still calls it — animations removed.
  function scheduleVisualOnIfPending() {
    state.pendingVisualOnAt = null;
    if (state.visualOnTimer) {
      clearTimeout(state.visualOnTimer);
      state.visualOnTimer = null;
    }
  }

  function ensureToggleExists() {
    if (document.getElementById("pmo-toggle-row")) return;
    var container =
      document.querySelector(".cart-drawer__body") ||
      document.querySelector("#CartDrawer .drawer__footer") ||
      document.querySelector("#CartDrawer .drawer__inner");
    if (!container) return;
    var checkoutBtn = container.querySelector(
      'button[name="checkout"], button[type="submit"][name="checkout"], .cart__checkout'
    );
    var row = document.createElement("div");
    row.className = "cart__item-row";
    row.id = "pmo-toggle-row";
    row.style.display = "flex";
    row.style.alignItems = "center";
    row.style.justifyContent = "space-between";
    row.innerHTML =
      '<label for="pmo-toggle" style="display:flex; align-items:center; gap:8px;"><input type="checkbox" id="pmo-toggle" /><span>Protect My Order</span></label><span id="pmo-price" style="white-space:nowrap;"></span>';
    if (checkoutBtn && checkoutBtn.parentNode) {
      checkoutBtn.parentNode.insertBefore(row, checkoutBtn);
    } else {
      container.appendChild(row);
    }
  }

  function hideProtectItemInDrawer() {
    try {
      var items = document.querySelectorAll(
        "#CartDrawer .cart__item[data-handle]"
      );
      items.forEach(function (el) {
        var handle = el.getAttribute("data-handle");
        if (handle === PROTECT_PRODUCT_HANDLE) {
          el.style.display = "none";
        }
      });
    } catch (e) {}
  }
  function setDrawerEmptyState(isEmpty) {
    try {
      var inner = document.querySelector("#CartDrawer .drawer__inner");
      var empty = document.querySelector("#CartDrawer .drawer__cart-empty");
      if (isEmpty) {
        // Force empty UI even when a Protect line item still exists in cart.js
        if (inner) inner.style.display = "none";
        if (empty) empty.style.display = "block";
      } else {
        // Clear overrides so theme .is-empty CSS can apply. Forcing empty to
        // display:none here raced with buildCart and blanked the whole drawer.
        if (inner) inner.style.display = "";
        if (empty) empty.style.display = "";
      }
      var row = document.getElementById("pmo-toggle-row");
      if (row) row.style.display = isEmpty ? "none" : "";
    } catch (e) {}
  }
})();
